module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAOhJREFUKJHNkMFNw0AURN//u6QJo0Qy9BFbpA0HEeoKSJgyjPYAbRAUQ5og6/0ckCM7yiUXxJzfSG8G/l0EYFsur1wna5mkZdbU7RDY3tzlrmMtPt5mTd0qgDP3jOrc9hp2i2o6hCUSgKL79g8AHiCZVioxIJrbnrBbVGU07yUSVJhiaeMmaXVQAmjn99cqMYBeGvZhJq6H5SKVvaoMdEclgGMYQM996VA4Vkrw+btpfISegtV3hTmKUyUFUEn1EM6aup29PG5MuhLSF6J5f6v2txrpzYmOBs7C03snVhi8uklcnbv3j/IDk1qBhz0yl7oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/wrong.png
// module id = 8
// module chunks = 0